import styled from "styled-components";
import { TableCell as TableCells } from "@mui/material";

export const TableHeadCell = styled(TableCells)`
    font-size: 12px !important;
    font-weight: 600 !important;
    width: ${(props: any): string => props.minwidth ? props.minwidth : '60px'};
    min-width:${(props: any): string => props.minwidth ? props.minwidth : '60px'};
    padding: ${(props: any): string => props.minwidth ? '12px 8px !important' : '8px !important'}
`;
